(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["garcon-cookie-consent"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('garcon-cookie-consent')) {
  customElements.define('garcon-cookie-consent', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.banner = this.querySelector('.gd-cookie');
      this.error = this.querySelector('.gd-cookie-error');
      this.buttons = [...this.querySelectorAll('[data-consent]')];
      this.settingsButton = this.querySelector('[data-cookie-settings]');
      this.settingsButton.addEventListener('click', () => {
        this.banner.hidden = false;
        this.querySelector('h2').focus();
      });
      this.buttons.forEach(button => button.addEventListener('click', () => this.save(button.dataset.consent === 'all')));
      this.load().then(api => {
        const consent = api.currentVisitorConsent();
        this.banner.hidden = ['analytics', 'marketing', 'preferences'].every(key => ['yes', 'no'].includes(consent[key]));
      }).catch(() => { this.banner.hidden = false; this.error.hidden = false; });
    }
    load() {
      if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
      if (this.loading) return this.loading;
      this.loading = new Promise((resolve, reject) => {
        const deadline = Date.now() + 10000;
        const timer = setTimeout(() => reject(new Error('Privacy API unavailable')), 12000);
        const finish = error => {
          clearTimeout(timer);
          if (error || !window.Shopify?.customerPrivacy) reject(error || new Error('Privacy API unavailable'));
          else resolve(window.Shopify.customerPrivacy);
        };
        const start = () => {
          if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], finish);
          else if (Date.now() < deadline) setTimeout(start, 100);
          else finish(new Error('Privacy API unavailable'));
        };
        start();
      }).finally(() => { this.loading = null; });
      return this.loading;
    }
    async save(accepted) {
      this.buttons.forEach(button => { button.disabled = true; });
      this.error.hidden = true;
      try {
        const api = await this.load();
        await new Promise((resolve, reject) => {
          const timer = setTimeout(() => reject(new Error('Consent save timed out')), 12000);
          api.setTrackingConsent({analytics:accepted,marketing:accepted,preferences:accepted}, result => {
            clearTimeout(timer);
            if (result?.error) reject(new Error(result.error));
            else resolve();
          });
        });
        const hadFocus = this.banner.contains(document.activeElement);
        this.banner.hidden = true;
        if (hadFocus) this.settingsButton.focus({preventScroll:true});
      } catch (_) { this.error.hidden = false; }
      finally { this.buttons.forEach(button => { button.disabled = false; }); }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
